const CONST = require('plugin_frontend_core/constants');

const selectors = {
    scrollToLink: '.js-scrollto'
};

/**
* Scrolls to element with animation
* JVP @TODO: Add check/have option to account for a possible sticky header
* @param {event} e - The click event
*/
function animateScrollToElement(e) {
    const $self = $(e.target);
    const targetElement = $self.attr(CONST.attributes.href);

    if (!$(targetElement)[0]) {
        return;
    }

    e.preventDefault();
    const scrollPosTarget = $(targetElement).offset().top;

    $(CONST.selectors.htmlBody).animate({
        scrollTop: scrollPosTarget
    }, CONST.times.scrollToAnimation);
}

/**
* Binds event handlers
*/
function bindEventHandlers() {
    const $doc = $(document);

    $doc.on(CONST.events.click, selectors.scrollToLink, animateScrollToElement);
}

/**
* Initializes the module
*/
function init() {
    bindEventHandlers();
}

module.exports = {
    init: init
};
